export const UPDATE_QUAD_FLASH = "UPDATE_QUAD_FLASH";
export const UPDATE_CURRENT_COLOR_LIST = "UPDATE_CURRENT_COLOR_LIST";
export const UPDATE_COUNTER = "UPDATE_COUNTER";
export const UPDATE_CURRENT_COUNTER = "UPDATE_CURRENT_COUNTER";
export const RESET = "RESET";
export const SET_CURRENT_HIGHEST_SCORE = "SET_CURRENT_HIGHEST_SCORE";
export const SET_INPUT_LOCKED = "SET_INPUT_LOCKED";
